import React from 'react';
import { Sparkles } from 'lucide-react';
import './AiBadge.css';

// Small animated "AI-powered" indicator: a shimmering coral pill with a
// pulsing Sparkles glyph. Purely decorative; the title/aria-label carry meaning.
const AiBadge = ({ label = 'AI', title = 'AI-powered' }) => (
  <span className="ai-badge" title={title} aria-label={title} role="img">
    <Sparkles size={12} className="ai-badge-icon" aria-hidden="true" />
    <span className="ai-badge-label">{label}</span>
    <span className="ai-badge-shine" aria-hidden="true" />
  </span>
);

export default AiBadge;
